import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isReadOnlyLocalCalendar } from 'owa-calendar-cache';
import {
    isNewCalendarItem,
    isMeetingOnCalendarSharedWithMe,
} from 'owa-calendar-event-capabilities';

export default function canModify(item: CalendarEvent): boolean {
    return (
        !!item.EffectiveRights &&
        !!item.EffectiveRights.Modify &&
        !isReadOnlyLocalCalendar(item.ParentFolderId.Id) &&
        !isNewCalendarItem(item) &&
        !(isMeetingOnCalendarSharedWithMe(item) && item.Sensitivity == 'Private')
    );
}
